import "core-js/modules/es6.object.assign";
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
var Table = styled(Box).withConfig({
  displayName: "Table",
  componentId: "p0g5pf-0"
})(["", ";"], theme("Table"));
var Table$1 = as("table")(Table);
var TableWrapper = styled(Box).withConfig({
  displayName: "TableWrapper",
  componentId: "sc-116i37u-0"
})(["max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;", ";"], theme("TableWrapper"));
var TableWrapper$1 = as("div")(TableWrapper);
var index = Object.assign(Table$1, {
  Wrapper: TableWrapper$1
});
export default index;